import React from "react";

import BarChart from "../BarChart";
import PieChart from "../PieChart";
import { getColor } from "../../tools";

function OccurrenceBoard({
  rom,
  occurrences,
  data,
  table,
  selectedLabels,
  choiceLabelsChecked,
  labelOpacity,
  setLabelOpacity,
  thumbnail,
  error,
  showValues,
  verticalBars,
  pieChart,
  sortDec,
}) {
  // create the data object
  const getData = () => {
    return selectedLabels.map((selectedLabel) => ({
      name: table.filter((row) => row.id === selectedLabel)?.[0]?.label ?? selectedLabel,
      label: occurrences?.[selectedLabel] ?? 0,
      label$label: selectedLabel,
      label$color: getColor(selectedLabel),
      label$numberOfMeasurements: occurrences?.[selectedLabel],
    }));
  };

  return (
    <React.Fragment>
      {pieChart ? (
        <PieChart
          data={getData()}
          quantitativeLabelsChecked={[{ id: "label", label: "" }]}
          height={!thumbnail ? 250 : 80}
          thumbnail={thumbnail}
          showValues={showValues}
          sortDec={sortDec}
          isAbsolute={true}
        />
      ) : (
        <BarChart
          data={getData()}
          quantitativeLabelsChecked={[{ id: "label", label: "" }]}
          opacity={labelOpacity}
          height={!thumbnail ? 250 : 80}
          thumbnail={thumbnail}
          error={error}
          showValues={showValues}
          verticalBars={verticalBars}
          sortDec={sortDec}
          isAbsolute={true}
        />
      )}
    </React.Fragment>
  );
}

export default OccurrenceBoard;
